module.exports = __webpack_public_path__ + "43038aaa6feef05d732244c597b760f8.svg";